import { IconManager } from 'components/_universal/IconManager/IconManager';
import { useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import {
    Control,
    FieldError,
    FieldErrors,
    useController,
} from 'react-hook-form';
import { IconName } from 'types/CommonTypes';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import {
    EyeIconWrapper,
    IconWrapper,
    Input,
    InputLabel,
    InputWrapper,
} from './TextInput.styled';

export interface TextInputProps {
    borderRadius?: number;
    control: Control<any, any>;
    disabled?: boolean;
    errors?: FieldError | FieldErrors;
    iconType?: IconName;
    label?: string;
    marginBottom?: number;
    maxLength?: number;
    name: string;
    onClick?: () => void;
    placeholder?: string;
    type: 'text' | 'email' | 'password' | 'number';
}

export const TextInput = ({
    borderRadius,
    control,
    disabled,
    errors,
    iconType,
    label,
    marginBottom,
    maxLength,
    name,
    onClick,
    placeholder,
    type,
}: TextInputProps) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const {
        field: { onChange, value },
    } = useController({
        name,
        control,
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        if (type === 'number') {
            // Usuwamy niedozwolone znaki
            value = value.replace(/[^0-9.-]/g, '');

            // Ograniczamy długość ręcznie, bo maxLength nie działa dla type="number"
            if (maxLength && value.length > maxLength) {
                value = value.slice(0, maxLength);
            }
        }

        onChange(value);
    };

    return (
        <InputWrapper marginBottom={marginBottom} isError={!!errors}>
            {iconType && (
                <IconWrapper>
                    <IconManager cursorPointer name={iconType} size={24} />
                </IconWrapper>
            )}
            <Input
                customBorderRadius={borderRadius}
                disabled={disabled}
                id={name}
                isDisabled={disabled}
                isError={!!errors}
                isIcon={!!iconType}
                name={name}
                onChange={handleChange}
                onClick={onClick}
                onFocus={onClick}
                placeholder={placeholder}
                inputType={type}
                type={
                    type === 'password'
                        ? isPasswordVisible
                            ? 'text'
                            : 'password'
                        : type
                }
                value={value}
                maxLength={type === 'number' ? undefined : maxLength}
                inputMode={type === 'number' ? 'numeric' : undefined}
                style={
                    type === 'number' ? { appearance: 'textfield' } : undefined
                }
            />
            {type === 'password' && (
                <EyeIconWrapper
                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                >
                    <IconManager
                        cursorPointer
                        name={isPasswordVisible ? 'SlashEye' : 'Eye'}
                        size={24}
                    />
                </EyeIconWrapper>
            )}
            {label && <InputLabel>{label}</InputLabel>}
            {errors && (
                <Fade direction="up" triggerOnce>
                    <ErrorMessage error={errors} />
                </Fade>
            )}
        </InputWrapper>
    );
};
